var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tci-service-head',{attrs:{"title":_vm.$t('service.service3.title'),"subtitle":_vm.$t('service.service3.subtitle'),"content":_vm.$t('service.service3.content'),"imgUrl":_vm.$i18n.locale=="zh"?require("../assets/service/s3-1.jpg"):require("../assets/service/s3-1-ja.jpg")}}),_c('tci-contact-footer',{attrs:{"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }